import { useQuery } from "@apollo/client";
import {
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";

import { GET_ACTIVITY_LOGS } from "apollo/queries";
import ProductEditModal from "components/Product/productEditModal";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { formatLocalDate } from "utiles/url";

const Activity = () => {
  const [size, setSize] = useState("10"); // Default page size
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [openedDetail, setOpenedDetail] = useState(false);
  //
  const [opened, setOpened] = useState(false);
  const [editId, setEditId] = useState();
  const [deleteID, setDeleteID] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const theme = useMantineTheme();

  const { data, loading, fetchMore } = useQuery(GET_ACTIVITY_LOGS, {
    variables: {
      first: parseInt(size), // Pass size dynamically
      page: activePage,
      from_date: selectedStartDate
        ? formatLocalDate(selectedStartDate)
        : undefined,
      to_date: selectedEndDate ? formatLocalDate(selectedEndDate) : undefined,
      ordered_by: [
        {
          column: "CREATED_AT",
          order: "DESC",
        },
      ],
    },
  });
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };
  useEffect(() => {
    if (data) {
      setTotal(data.getActivityLogs.paginatorInfo.lastPage);
    }
  }, [data, size]);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  useEffect(() => {
    setActivePage(1);
  }, [selectedStartDate, selectedEndDate]);

  const handleChange = (currentPage) => {
    fetchMore({
      variables: {
        first: size,
        page: currentPage,
      },
    });
    setActivePage(currentPage);
  };

  if (!hasMounted) {
    return null;
  }

  const headerData = [
    {
      label: "Name",
      key: "name",
      sortable: true,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.log_name}</span>;
      },
    },
    {
      label: "Event",
      key: "event",
      sortable: true,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.event}</span>;
      },
    },
    {
      label: "User",
      key: "causer",
      sortable: true,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.causer?.name}</span>;
      },
    },
    {
      label: "Details",
      key: "details",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        const properties = JSON.parse(rowData.properties); // Parse properties JSON

        // Check log_name and return corresponding data
        if (rowData.log_name === "cart") {
          return <span>Quantity: {properties.quantity}</span>;
        } else if (
          rowData.log_name === "order" ||
          rowData.log_name === "dropoff"
        ) {
          return (
            <span>
              Status: {properties.items?.[0]?.state || properties.status}
            </span>
          );
        }
        return null;
      },
    },

    {
      label: "Date",
      key: "created_at",
      sortable: true,
      searchable: false,
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
  ];

  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedEdit}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        onClose={() => setOpenedEdit(false)}
        title="Editing a Product"
        padding="xl"
        size="80%"
        position="bottom"
      >
        <ProductEditModal
          openedEdit={openedEdit}
          setOpenedEdit={setOpenedEdit}
          editId={editId}
        />
      </Drawer>
      <Card shadow="sm" p="lg">
        <Group justify="flex-start" gap="md" mb="md">
          <DatePicker
            style={{ minWidth: "140px" }}
            value={selectedStartDate}
            onChange={setSelectedStartDate}
            placeholder="Start Date"
            popoverProps={{ withinPortal: true, zIndex: 10001 }}
            clearable
          />
          <DatePicker
            style={{ minWidth: "140px" }}
            value={selectedEndDate}
            onChange={setSelectedEndDate}
            placeholder="End Date"
            popoverProps={{ withinPortal: true, zIndex: 10001 }}
            clearable
          />
        </Group>
        <ScrollArea>
          <B2bTable
            total={total}
            activePage={activePage}
            searchInput={false}
            handleChange={handleChange}
            header={headerData}
            paginatorInfo={data?.getActivityLogs?.paginatorInfo}
            loading={loading}
            data={data ? data.getActivityLogs.data : []}
            size={size}
            handlePageSizeChange={handlePageSizeChange}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default Activity;
